import VerifyAcc from "../section/auth/VerifAccount";

export default function AccountVerified(){
    return(
        <VerifyAcc />
    )
}